import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getNextIdThunk, getNftPaginateThunk } from './nftThunk';

const defaultPage = {
  docs: [],
  hasMore: false,
  hasNextPage: false,
  hasPrevPage: false,
  limit: 8,
  page: 1,
  pagingCounter: 1,
  totalDocs: 1,
  totalPages: 1,
};

const initialState = {
  isLoading: false,
  data: null,
  nextId: 0,
  paginate: { ...defaultPage },
};

export const getNftPaginate = createAsyncThunk(
  'nft/paginate',
  getNftPaginateThunk
);

export const getNextId = createAsyncThunk('nft/getNextId', getNextIdThunk);

const nftSlice = createSlice({
  name: 'nft',
  initialState,
  reducers: {
    setPage: (state, { payload }) => {
      state.paginate.page = payload.page;
    },
    setSelected: (state, { payload }) => {
      const { data } = payload;
      state.data = data;
    },
  },
  extraReducers: {
    [getNftPaginate.pending]: (state) => {
      state.isLoading = true;
    },
    [getNftPaginate.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.paginate = payload;
    },
    [getNftPaginate.rejected]: (state) => {
      state.isLoading = false;
      state.paginate = { ...defaultPage };
    },
    [getNextId.fulfilled]: (state, { payload }) => {
      const { nextId } = payload;
      console.log(payload);
      state.nextId = nextId;
    },
  },
});

export const { setPage, setSelected } = nftSlice.actions;
export default nftSlice.reducer;
